<script lang="ts">
  import SearchIcon from "@lucide/svelte/icons/search";
  import XIcon from "@lucide/svelte/icons/x";
  import { Command } from "bits-ui";

  import ClickableIcon from "$lib/design-systems/product/primitives/buttons/ClickableIcon.svelte";

  type Props = {
    value: string;
    onClear: () => void;
    placeholder?: string;
  };

  let {
    value = $bindable(""),
    onClear,
    placeholder = "Enter an ID or search...",
  }: Props = $props();
</script>

<div class="flex h-5 items-center gap-2.5">
  <SearchIcon size={16} class="shrink-0 icon-secondary" />
  <Command.Input
    bind:value
    {placeholder}
    class="command-palette-input h-5 w-full pl-0 text-sm text-primary placeholder:text-secondary"
  />
  {#if value.trim()}
    <ClickableIcon Icon={XIcon} onclick={onClear} />
  {/if}
</div>

<style>
  :global(.command-palette-input),
  :global(.command-palette-input:focus) {
    border: none;
    box-shadow: none;
    background: transparent;
  }
</style>
